"use client";

import { useState } from "react";
import { getActiveCart } from "../slice/cart-slice";
import { useAppSelector } from "../slice/hooks";
import StoreBox from "./store-box";
import CartModal from "./cart-modal";
import Progress from "./progress";

const CartPage = (props) => {
  const {
    closeModal,
    showProduct,
    accessPoint,
    activateBackButton,
    storePath,
    modal,
    checkoutState,
    setCheckoutState,
    showProgress,
    setShowProgress,
    organisation,
  } = props;
  const cart = useAppSelector(getActiveCart);

  const [isPageMode, setIsPageMode] = useState(modal ? false : true);
  const [publicUser, setPublicUser] = useState(null);

  const handleActivateBackButton = (show, onClickBackButton = null) => {
    activateBackButton?.(show, onClickBackButton);
    setShowProgress(show);
  };

  return (
    <StoreBox
      {...props}
      handleLocationChange={() => {}}
      isPageMode={isPageMode}
    >
      <div className="cart-container">
        <div className="cart-div">
          <div className="auth-form-header ">
            {showProgress && (
              <div className="auth-form-header">
                <Progress
                  checkoutState={checkoutState}
                  setCheckoutState={setCheckoutState}
                  accessPoint={accessPoint}
                  publicUser={publicUser}
                />
              </div>
            )}
          </div>
          <CartModal
            cart={cart}
            showProduct={showProduct}
            closeModal={closeModal}
            accessPoint={accessPoint}
            activateBackButton={handleActivateBackButton}
            checkoutState={checkoutState}
            setCheckoutState={setCheckoutState}
            publicUser={publicUser}
            setPublicUser={setPublicUser}
            isPageMode={isPageMode}
            storePath={storePath}
            organisation={organisation}
          />
        </div>
      </div>
    </StoreBox>
  );
};

export default CartPage;
